import src from "IMAGE";
export default { src, width: 405, height: 494, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
